import PropTypes from 'prop-types'

import cn from '@/utilities/cn'

const Value = ({ children, className }: any) => {
  return <div className={cn(className, 'keyvalues__value')}>{children}</div>
}

Value.displayName = 'Value'

Value.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
}

Value.defaultProps = {
  children: '',
  className: ''
}

export default Value
